import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/WorkingHour`;

export const GetWorkingHourList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/GetWorkingHourList`,
    params
  );
  return res;
};

export const AddUpdateWorkingHour = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/AddUpdateWorkingHour`,
    params
  );
  return res;
};
export const GetWorkingHourModel = async (KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetWorkingHourModel?UserKeyID=${UserKeyID}&WHLKeyID=${KeyID}`
  );
  return res;
};

export const GetWorkingHourLookupList = async (userKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetWorkingHourLookupList?UserKeyID=${userKeyID}`
  );
  return res;
};
